import Rate, { type RateProps } from "@client/controls/Rate/component";
import withValueHOC from "@client/hocs/withValue";
import { type WithOnChange, type WithValue } from "@client/types";
import React from "react";

export type RateInputProps = Omit<RateProps, "onClick" & "rate"> & {} & WithValue<number> & WithOnChange<number>;
const RateInputBase = ({ onChange, value, ...props }: RateInputProps) => (
  <Rate {...props} rate={value} onClick={onChange} />
);
const RateInput = withValueHOC<string, RateInputProps>(RateInputBase);
export default RateInput;
